export default __webpack_public_path__ + "static/media/paso17.3514f062.png";